import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 1F476F4F-1689-4729-A5A5-A2BB1C49DC90
 * name monitor-vertical
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-vertical.svg
 * tags
 */
export const MonitorVerticalIcon = createSvgIcon(<><path d="M16 2H8C6.89 2 6 2.89 6 4V16C6 17.11 6.9 18 8 18H10V20H8V22H16V20H14V18H16C17.11 18 18 17.11 18 16V4C18 2.89 17.1 2 16 2M16 16H8V4H16V16Z" /></>, 'MonitorVerticalIcon');
export default MonitorVerticalIcon